import { Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import TrafficSourceFilterCard from "./TrafficSourceFilter/TrafficSourceFilterCard";
import TrafficSourceTable from "./TrafficSourceTable/TrafficSourceTable";
import { MetaEntitiesEndPointLogic } from "../../../../logic/Admin/MetaEntities/MetaEntitiesEndPointLogic";
import { selectUserData, setIsLoading } from "../../../../features/userSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Page404 from "../../../Page404/Page403";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import SimpleBackdrop from "../../../BackDrop/BackDrop";

interface TrafficSourceProps {
  oauthTokenHeader: any;
}

const tableHeadings = {
  traffic_source_name: "Traffic Source Name",
  traffic_type: "Traffic Source Type",
  count_as_click_in_out: "Include Clicks In Reports",
  created: "Created on",
  created_by: "Created By",
  modified: "Last edited",
  modified_by: "Edited By",
};

const TrafficSource = ({ oauthTokenHeader }: TrafficSourceProps) => {
  const [selectedTrafficSource, setSelectedTrafficSource] = useState(null);
  const [metaTrafficSource, setMetaTrafficSource] = useState(null);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const response = useSelector(selectUserData);
  const hasViewTrafficSourcePermission = CheckPermissions(
    response?.data?.products?.admin,
    "meta_entities",
    "view_traffic_sources"
  );

  useEffect(() => {
    const fetchMetaEntitiesData = async () => {
      setIsLoading(true);
      setLoading(true);
      try {
        await MetaEntitiesEndPointLogic.getMetaTrafficSourceDuplicate(
          oauthTokenHeader,
          dispatch
        );
      } catch (error) {
        console.error("Error fetching Meta Entities:", error);
      } finally {
        setIsLoading(false);
        setLoading(false);
      }
    };

    if (oauthTokenHeader) {
      fetchMetaEntitiesData();
    }
  }, [oauthTokenHeader, dispatch]);

  if (!hasViewTrafficSourcePermission) {
    return <Page404 />;
  }

  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <>
          <Paper
            sx={{
              boxShadow: "none",
              padding: "8px 16px 0px",
              borderEndEndRadius: "0px",
              borderBottomLeftRadius: "0px",
            }}
          >
            <Typography fontSize={24}>Traffic Source List</Typography>
            <TrafficSourceFilterCard />
          </Paper>
          <Paper
            sx={{
              boxShadow: "none",
              borderTopLeftRadius: "0px",
              borderTopRightRadius: "0px",
            }}
          >
            <TrafficSourceTable
              selectedTrafficSource={selectedTrafficSource}
              setSelectedTrafficSource={setSelectedTrafficSource}
              tableHeadings={tableHeadings}
              setMetaTrafficSource={setMetaTrafficSource}
              oauthTokenHeader={oauthTokenHeader}
              loading={loading}
              metaTrafficSource={metaTrafficSource}
            />
          </Paper>
        </>
      )}
    </>
  );
};

export default TrafficSource;
